// extracted by mini-css-extract-plugin
export default {"nothing":"NothingFound_nothing__2KQ3P"};